import React from 'react'

const RangePlaceholder = props => (
  <div className='range-step row border-color-ui-3 border-bottom pb-2 mb-2'>
    <div className='col-6 col-md-3 order-2 order-md-1 px-0'>
      <div className='row mx-0'>
        <div className='col-11 px-2 radius bg-ui-3 py-2' />
      </div>
    </div>
    <div className='col-12 col-md-6 order-1 order-md-2 px-0'>
      <div className='row align-items-center h-100'>
        <div className='col-12 px-2 mb-2 mb-md-0 mx-0'>
          <div className='col-12 px-2 radius bg-ui-3 pt-1 mb-1' />
        </div>
      </div>
    </div>
    <div className='col-6 col-md-3 order-3 order-md-3 form-field'>
      <div className='row mx-0'>
        <div className='col-11 px-2 radius bg-ui-3 py-2' />
      </div>
    </div>
  </div>
)

export default RangePlaceholder



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/PointsCash/RangePlaceholder.js